function getStorage() {
  if (typeof window === 'undefined' || !window.sessionStorage) return null
  return window.sessionStorage
}

export function readPageCache(key, maxAgeMs = 0) {
  const storage = getStorage()
  if (!storage || !key) return null

  try {
    const raw = storage.getItem(key)
    if (!raw) return null

    const parsed = JSON.parse(raw)
    const savedAt = Number(parsed && parsed.savedAt ? parsed.savedAt : 0)
    if (!savedAt) return null
    if (maxAgeMs > 0 && (Date.now() - savedAt) > maxAgeMs) return null
    return parsed.data
  } catch (error) {
    return null
  }
}

export function writePageCache(key, data) {
  const storage = getStorage()
  if (!storage || !key) return

  try {
    storage.setItem(key, JSON.stringify({
      savedAt: Date.now(),
      data
    }))
  } catch (error) {
    // Ignore cache write issues so the page still works normally.
  }
}

export function clearPageCache(key) {
  const storage = getStorage()
  if (!storage || !key) return

  try {
    storage.removeItem(key)
  } catch (error) {
    // Ignore cache clear issues so the page still works normally.
  }
}
